<template>
  <!-- 得得用车 -->
  <!-- pc端 -->
  <div v-if="isPCFlag" class="solutionSafety">
    <!-- 第一部分顶部大图导航 -->
    <topBigPic :topBgImg="topBgImg" :bigTitle="bigTitle" :menuLi="menuLi"></topBigPic>

    <!-- 第二部分 -->
    <div class="containers">
      <div class="honor_header ">
        <h1 ref="HeaderTitle">产品简介</h1>
        <div ref="honorMain" class="containers mian_Info" style="margin:0">
          <p>致力于企业自有车辆管理，提供软硬一体的全方位数字智能化综合解决方案，全面解决传统管车模式中成本不可控、效率低下的问题。</p><br /><br />
          <p>得得用车通过企业车辆使用与管控中的“人、车、路、费、数”等多要素统一协同为出发点，基于智能钥匙柜、智能油卡柜、酒精测试仪三大智能硬件基础设施，辅以智能调度、能耗费用、绩效结算、智能报表、安全监测五大引擎，建设“互联、智能、可视、高效、共享”的车辆管理移动化应用，为企业车辆管理的自动化、信息化、智能化、数字化转型升级注入新动力。</p>
        </div>
        <div class="honorImg" ref="honorImg">
          <div class="shade" ref="shadeHonorImg"></div>
          <img src="../../assets/imgs/dedeauto/introduction.jpg" ref="imgHonorImg">
        </div>
      </div>
    </div>

    <!-- 目标用户部分 -->
    <targetuser :targetuser="targetuser"></targetuser>

    <!-- 智能硬件基础设施 -->
    <infrastructure></infrastructure>

    <!-- 软件服务部分 -->
    <softwaremaintenance :software="software"></softwaremaintenance>

    <!-- 覆盖区域轮播切换部分 -->
    <!-- <fugaiswiper :fugaiswiper="fugaiswiper"></fugaiswiper> -->
    <div class="fugaiswiper">
      <!-- tab切换 -->
      <div class="tab_check containers">
        <div @click="coveraged" :class="tabCheck=='已覆盖'?'ons':''">已覆盖</div>
        <div @click="beforeCoverage" :class="tabCheck=='拟覆盖'?'ons':''">拟覆盖</div>
      </div>
      <!-- 两个部分的轮播 -->
      <fugaiswipered :fugaiswipered="fugaiswipered" v-if="tabCheck=='已覆盖'"></fugaiswipered>
      <fugaiswiper :fugaiswiper="beforefugaiswiper" v-else></fugaiswiper>
    </div>

    <!-- 底部大图部分 -->
    <div class="about_partfour vision_planning">
      <div class="about_part4" ref="part4">
        <div ref="mainfontFour">
          <p>产品愿景</p>
          <h1>成为企业车务管理细分领域领导者</h1>
        </div>
      </div>
    </div>
    <!-- Safari浏览器会出现白色线，放个空盒子消除遮盖 -->
    <div></div>

    <!-- 尾部公用组件 -->
    <bottomFooter></bottomFooter>
  </div>
  <!-- 移动端 -->
  <div v-else class="mobileSolutionSafety">
    <!-- 第一部分顶部大图导航 -->
    <mobileTopBigPic :topBgImg="mobileTopBgImg" :bigTitle="bigTitle" :menuLi="menuLi"></mobileTopBigPic>

    <!-- 第二部分 -->
    <div class="mobile-about-part2">
      <div class="title ml71">
        产品简介
      </div>
      <div class="info mobile-container padding-bottom-213">
        致力于企业自有车辆管理，提供软硬一体的全方位数字智能化综合解决方案，全面解决传统管车模式中成本不可控、效率低下的问题。<br /><br />
        得得用车通过企业车辆使用与管控中的“人、车、路、费、数”等多要素统一协同为出发点，基于智能钥匙柜、智能油卡柜、酒精测试仪三大智能硬件基础设施，辅以智能调度、能耗费用、绩效结算、智能报表、安全监测五大引擎，建设“互联、智能、可视、高效、共享”的车辆管理移动化应用，为企业车辆管理的自动化、信息化、智能化、数字化转型升级注入新动力。
      </div>
      <div class="bg"></div>
    </div>

    <!-- 目标用户部分 -->
    <mbTargetuser :targetuser="mbTargetuser"></mbTargetuser>

    <!-- 智能硬件基础设施 -->
    <mbInfrastructure></mbInfrastructure>

    <!-- 软件服务部分 -->
    <mbSoftwaremaintenance :software="software"></mbSoftwaremaintenance>

    <!-- 覆盖区域轮播切换部分 -->
    <!-- <fugaiswiper :fugaiswiper="fugaiswiper"></fugaiswiper> -->
    <div class="fugaiswiper-mb">
      <!-- tab切换 -->
      <div class="tab_check-mb">
        <div @click="coveraged" :class="tabCheck=='已覆盖'?'ons':''">已覆盖</div>
        <div @click="beforeCoverage" :class="tabCheck=='拟覆盖'?'ons':''">拟覆盖</div>
      </div>
      <!-- 两个部分的轮播 -->
      <mbFugaiswipered :fugaiswipered="fugaiswipered" v-if="tabCheck=='已覆盖'"></mbFugaiswipered>
      <mbFugaiswiper :fugaiswiper="beforefugaiswiper" v-else></mbFugaiswiper>
    </div>

    <!-- 底部大图部分 -->
    <div class="about_partfour-mb">
      <div class="about_part4-mb" ref="part4">
        <div class="mainfontFour">
          <p>产品愿景</p>
          <h1>成为企业车务管理细分领域领导者</h1>
        </div>
      </div>
    </div>
    <!-- Safari浏览器会出现白色线，放个空盒子消除遮盖 -->
    <div></div>

    <!-- 尾部公用组件 -->
    <mobileBottomFooter></mobileBottomFooter>
  </div>
</template>

<script>
import topBigPic from "@/components/global/topBigPic.vue";
import bottomFooter from "@/components/global/bottomFooter.vue";
import targetuser from "@/components/dedeauto/targetuser.vue";
import softwaremaintenance from "@/components/dedeauto/softwaremaintenance.vue";
import fugaiswiper from "@/components/dedeauto/fugaiswiper.vue";
import fugaiswipered from "@/components/dedeauto/fugaiswipered.vue";
import infrastructure from "@/components/dedeauto/infrastructure.vue";
import mobileTopBigPic from "@/components/global/mobileTopBigPic";
import mobileBottomFooter from "@/components/global/mobileBottomFooter.vue";
import mbTargetuser from "@/components/dedeauto/mbTargetuser.vue";
import mbSoftwaremaintenance from "@/components/dedeauto/mbSoftwaremaintenance.vue";
import mbFugaiswiper from "@/components/dedeauto/mbFugaiswiper.vue";
import mbFugaiswipered from "@/components/dedeauto/mbFugaiswipered.vue";
import mbInfrastructure from "@/components/dedeauto/mbInfrastructure.vue";

import animationUtils from "@/utils/animationUtils.js";
import { isPC } from "@/utils/tools.js";

export default {
  name: "comdedeauto",
  data() {
    return {
      isPCFlag: true,
      // tab切换
      tabCheck: "已覆盖",
      //顶部导航数据
      topBgImg: require("../../assets/imgs/dedeauto/top-bg.jpg"),
      mobileTopBgImg: require("../../assets/imgs/mbDedeauto/top-bg.jpg"),
      bigTitle: {
        znTitle: "得得用车",
        enTitle: "DEDE AUTO",
      },
      menuLi: {
        sortOne: {
          title: "产品中心",
          children: [
            {
              name: "产品中心",
              active: true,
              url: "/comdedeauto",
            },
            {
              name: "解决方案",
              active: false,
              url: "/solutionadmi",
            },
            {
              name: "新闻动态",
              active: false,
              url: "/companyNews",
            },
            {
              name: "关于我们",
              active: false,
              url: "/companyprofile",
            },
            {
              name: "职等你来",
              active: false,
              url: "/jobmarket",
            },
          ],
        },

        sortTwo: {
          title: "得得用车",
          children: [
            {
              name: "得得用车",
              active: true,
              url: "/comdedeauto",
            },
          ],
        },
      },
      //主要功能
      targetuser: [
        {
          bg: require("../../assets/imgs/dedeauto/SOEs.jpg"),
          title: "国企",
        },
        {
          bg: require("../../assets/imgs/dedeauto/public_institution.jpg"),
          title: "事业单位",
        },
        {
          bg: require("../../assets/imgs/dedeauto/logistics.jpg"),
          title: "物流",
        },
        {
          bg: require("../../assets/imgs/dedeauto/private_sector_team.jpg"),
          title: "私企车队",
        },
        {
          bg: require("../../assets/imgs/dedeauto/other.jpg"),
          title: "其他",
        },
      ],
      //主要功能
      mbTargetuser: [
        {
          bg: require("../../assets/imgs/mbDedeauto/SOEs.jpg"),
          title: "国企",
        },
        {
          bg: require("../../assets/imgs/mbDedeauto/public_institution.jpg"),
          title: "事业单位",
        },
        {
          bg: require("../../assets/imgs/mbDedeauto/logistics.jpg"),
          title: "物流",
        },
        {
          bg: require("../../assets/imgs/mbDedeauto/private_sector_team.jpg"),
          title: "私企车队",
        },
        {
          bg: require("../../assets/imgs/mbDedeauto/other.jpg"),
          title: "其他",
        },
      ],

      //软件服务
      software: [
        {
          leftimg: require("../../assets/imgs/dedeauto/Five_engine.jpg"),
          rightul: {
            title: "五大引擎",
            mianli: [
              {
                imgpic: require("../../assets/imgs/dedeauto/intelligent_scheduling.png"),
                titleLi: "智能调度",
                info: "千人千面，自动规避行程风险，调度车辆/驾驶员",
              },
              {
                imgpic: require("../../assets/imgs/dedeauto/Energy_costs.png"),
                titleLi: "能耗费用",
                info: "智能计算车辆能耗，自动结算车辆费用",
              },
              {
                imgpic: require("../../assets/imgs/dedeauto/performance_settlement.png"),
                titleLi: "绩效结算",
                info: "自定义绩效规则，自动结算驾驶员绩效",
              },
              {
                imgpic: require("../../assets/imgs/dedeauto/Intelligence_reports.png"),
                titleLi: "智能报表",
                info: "自定义各个维度报表，自定义格式导出",
              },
              {
                imgpic: require("../../assets/imgs/dedeauto/safety_monitoring.png"),
                titleLi: "安全监测",
                info: "对车辆、驾驶员、行程全方位无死角监测，发现异常即刻预警",
              },
            ],
          },
        },
        {
          leftimg: require("../../assets/imgs/dedeauto/Third-party_Interconnection.jpg"),
          rightul: {
            title: "第三方对接",
            mianli: [
              {
                imgpic: require("../../assets/imgs/dedeauto/break_rules.png"),
                titleLi: "违章查询平台对接",
                info: "",
              },
              {
                imgpic: require("../../assets/imgs/dedeauto/gasfilling_card.png"),
                titleLi: "加油卡平台对接",
                info: "",
              },
              {
                imgpic: require("../../assets/imgs/dedeauto/ETC.png"),
                titleLi: "ETC平台对接",
                info: "",
              },
            ],
          },
        },
      ],
      //已覆盖
      fugaiswipered: [
        {
          province: "四川",
          city: "成都",
          pic: require("../../assets/imgs/dedeauto/chengdu.jpg"),
        },
        {
          province: "四川",
          city: "眉山",
          pic: require("../../assets/imgs/dedeauto/meishan.jpg"),
        },
        {
          province: "四川",
          city: "资阳",
          pic: require("../../assets/imgs/dedeauto/ziyang.jpg"),
        },
        {
          province: "四川",
          city: "德阳",
          pic: require("../../assets/imgs/dedeauto/deyang.jpg"),
        },
        {
          province: "四川",
          city: "内江",
          pic: require("../../assets/imgs/dedeauto/neijiang.jpg"),
        },
        {
          province: "四川",
          city: "绵阳",
          pic: require("../../assets/imgs/dedeauto/mianyang.jpg"),
        },
        {
          province: "甘肃",
          city: "兰州",
          pic: require("../../assets/imgs/dedeauto/lanzhou.jpg"),
        },
        //因为界面轮播需要展示6张轮播元素，如果元素少于等于6个时，会造成不能正常循环轮播的情况，所以将数据直接写成两份，保证让轮播总元素大于6
        {
          province: "四川",
          city: "成都",
          pic: require("../../assets/imgs/dedeauto/chengdu.jpg"),
        },
        {
          province: "四川",
          city: "眉山",
          pic: require("../../assets/imgs/dedeauto/meishan.jpg"),
        },
        {
          province: "四川",
          city: "资阳",
          pic: require("../../assets/imgs/dedeauto/ziyang.jpg"),
        },
        {
          province: "四川",
          city: "德阳",
          pic: require("../../assets/imgs/dedeauto/deyang.jpg"),
        },
        {
          province: "四川",
          city: "内江",
          pic: require("../../assets/imgs/dedeauto/neijiang.jpg"),
        },
        {
          province: "四川",
          city: "绵阳",
          pic: require("../../assets/imgs/dedeauto/mianyang.jpg"),
        },
        {
          province: "甘肃",
          city: "兰州",
          pic: require("../../assets/imgs/dedeauto/lanzhou.jpg"),
        },
      ],
      //拟覆盖
      beforefugaiswiper: [
        {
          province: "广东",
          city: "深圳",
          pic: require("../../assets/imgs/dedeauto/shenzhen.jpg"),
        },
        {
          province: "云南",
          city: "昆明",
          pic: require("../../assets/imgs/dedeauto/kunming.jpg"),
        },
        {
          province: "贵州",
          city: "贵阳",
          pic: require("../../assets/imgs/dedeauto/guiyang.jpg"),
        },
        {
          province: "湖北",
          city: "武汉",
          pic: require("../../assets/imgs/dedeauto/wuhan.jpg"),
        },
        {
          province: "湖北",
          city: "宜昌",
          pic: require("../../assets/imgs/dedeauto/yichang.jpg"),
        },
        //因为界面轮播需要展示6张轮播元素，如果元素少于等于6个时，会造成不能正常循环轮播的情况，所以将数据直接写成两份，保证让轮播总元素大于6
        {
          province: "广东",
          city: "深圳",
          pic: require("../../assets/imgs/dedeauto/shenzhen.jpg"),
        },
        {
          province: "云南",
          city: "昆明",
          pic: require("../../assets/imgs/dedeauto/kunming.jpg"),
        },
        {
          province: "贵州",
          city: "贵阳",
          pic: require("../../assets/imgs/dedeauto/guiyang.jpg"),
        },
        {
          province: "湖北",
          city: "武汉",
          pic: require("../../assets/imgs/dedeauto/wuhan.jpg"),
        },
        {
          province: "湖北",
          city: "宜昌",
          pic: require("../../assets/imgs/dedeauto/yichang.jpg"),
        },
      ],
    };
  },
  created() {
    this.isPCFlag = isPC();
  },
  mounted() {
    this.isPCFlag ? window.addEventListener("scroll", this.menu) : "";
  },
  beforeDestroy() {
    //在加载时添加了scroll监听，如果不销毁，到下一个页面时，没有主动销毁，会报错'offsetTop' of undefined。因此，需要在页面跳转前销毁此监听
    this.isPCFlag ? window.removeEventListener("scroll", this.menu) : "";
  },
  beforeDestroy() {
    //在加载时添加了scroll监听，如果不销毁，到下一个页面时，没有主动销毁，会报错'offsetTop' of undefined。因此，需要在页面跳转前销毁此监听
    window.removeEventListener("scroll", this.menu);
  },
  methods: {
    coveraged() {
      this.tabCheck = "已覆盖";
    },
    beforeCoverage() {
      this.tabCheck = "拟覆盖";
    },
    //滚动条监听
    menu() {
      /**
       * animations方法的第一个参数是需要动画的dom元素的高度，
       * 第二个参数是需要加动画的dom元素的样式列表数组，
       * 第三参数是动画类型（样式类名）activeTitle：文字动画，activeShade图片出现前的遮罩动画，activeTitle图片动画
       */
      //第二部分标题动画
      let HeaderTitleOffsetTop = this.$refs.HeaderTitle.offsetTop; //获取当前元素距离文档顶部的高度
      let HeaderTitle = this.$refs.HeaderTitle.classList;
      //
      animationUtils.animations(
        HeaderTitleOffsetTop,
        HeaderTitle,
        "activeTitle"
      );

      //第二部分图的动画
      let honorImgOffsetTop = this.$refs.honorImg.offsetTop; //获取当前元素距离文档顶部的高度
      let shadeHonorImg = this.$refs.shadeHonorImg.classList; //遮罩样式数组
      let imgHonorImg = this.$refs.imgHonorImg.classList; //图片样式数组
      animationUtils.animations(
        honorImgOffsetTop,
        shadeHonorImg,
        "activeShade"
      );
      animationUtils.animations(honorImgOffsetTop, imgHonorImg, "activeImg");

      //第二部分文字描述动画
      let honorMainOffsetTop = this.$refs.honorMain.offsetTop;
      let honorMainClassList = this.$refs.honorMain.classList;
      animationUtils.animations(
        honorMainOffsetTop,
        honorMainClassList,
        "activeTitle"
      );

      //   底部大图部分描述动画
      let partFourOffsetTop = this.$refs.part4.offsetTop; //底部大图部分距离文档顶部的高度
      let partFourclassList = this.$refs.part4.classList; //底部大图部分距离文档顶部的高度
      animationUtils.animations(
        partFourOffsetTop,
        partFourclassList,
        "activeSecBg"
      );

      let mainfontFourOffsetTop = this.$refs.mainfontFour.offsetTop; //底部大图部分文字到文档顶部高度=底部大图部分高度+底部大图部分到底部大图部分盒子的高度
      // let mainfontFourOffsetTop =this.$refs.mainfontFour.offsetTop;;

      let mainfontFourClassList = this.$refs.mainfontFour.classList;
      animationUtils.animations(
        mainfontFourOffsetTop,
        mainfontFourClassList,
        "activeTitle"
      );
    },
  },
  components: {
    topBigPic,
    bottomFooter,
    targetuser,
    softwaremaintenance,
    fugaiswiper,
    fugaiswipered,
    infrastructure,
    mobileTopBigPic,
    mobileBottomFooter,
    mbTargetuser,
    mbSoftwaremaintenance,
    mbFugaiswiper,
    mbFugaiswipered,
    mbInfrastructure,
  },
};
</script>

<style lang="scss" scoped>
.mobileSolutionSafety {
  .padding-bottom-213 {
    padding-bottom: 213px;
  }

  .mobile-about-part2 {
    padding-bottom: 284px;
    .title {
      width: 1720px;
      height: 180px;
      line-height: 180px;
      font-size: 156px;
      font-weight: 600;
      padding: 284px 0 174px;
      box-sizing: content-box;
      color: #000000;
    }
    .bg {
      height: 1152px;
      background: url(../../assets/imgs/mbDedeauto/introduction.jpg) no-repeat;
      background-size: cover;
    }
    .info {
      font-size: 71px;
      font-weight: 400;
      color: #323333;
      line-height: 128px;
      text-align: justify;
    }
  }

  .fugaiswiper-mb {
    height: 2212px;
    padding: 286px 0;
    .tab_check-mb {
      width: 100%;
      border-bottom: 7px solid #dcdcde;
      display: flex;
      margin-bottom: 213px;
      div {
        margin-left: 238px;
        color: #999999;
        padding-bottom: 94px;
        font-size: 199px;
        cursor: pointer;
      }
      .ons {
        color: #2185f0 !important;
        border-bottom: 14px solid #2185f0 !important;
      }
    }
  }

  /* 第四部分 */
  .about_partfour-mb {
    width: 1920px;
    height: 2844px;
    overflow: hidden;
    .about_part4-mb {
      width: 100%;
      height: 100%;
      background: url("../../assets/imgs/dedeauto/vision_planning.jpg") #062652
        no-repeat 50% 50%;
      /* transform: scale(1); */
      background-size: cover !important;
      padding: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      box-sizing: border-box;
      .mainfontFour {
        text-align: center;
        color: #fff;
        p {
          font-size: 85px;
          margin-bottom: 156px;
        }
        h1 {
          width: 1600px;
          font-size: 199px;
        }
      }
    }
  }
}
</style>